export default "__VITE_ASSET__BXckVIWM__"